import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalContent from "../Shared/Modal/ReactModalContent";
import { modalActions } from '../../redux/root-action';
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import Indicator from "../../assets/indicator.svg";
import styled from 'styled-components';
// import {ProfileBeaconCheckbox} from "../Shared/ProfileBeaconComponents";
import ReactModalFooter from "../Shared/Modal/ReactModalFooter";
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {UseAppSelector} from "../../redux/configure-store";
import {
    getIsPerformanceInvOptionsChecked,
    getPlanProducts,
    getSelectedPerformanceServiceProducts,
    getServiceProducts
} from "../../redux/profile/selectors";
import {
    setIsPerformanceInvOptionsChecked, setSelectedPerformanceServiceProducts
} from "../../redux/profile/slice";
import _ from "lodash";
import { ProfileBeaconControl, ProfileBeaconControlGroup } from 'components/Shared/ProfileBeaconComponents';

const StyledContainer = styled.div`

`;

const StyledContent = styled.div`
  margin-top: 32px;
  padding-bottom: 34px;
  border-bottom: solid 2px #e9ebed;
  @media (max-width: 640px){
    padding-bottom: 24px;
  }
`;

const ImageContent  = styled.div`
  @media (max-width: 640px){
    margin-left:-6px;
  }
`;

const StyledCheckboxContainer = styled.div`
  padding-top: 14px;
`;

const StyledSection = styled.div`
  margin-top: 28px;
  @media (max-width: 768px){
    margin-top: 24px;
    margin-bottom: 24px;
  }
  @media (max-width: 640px){
    margin-top: 16px;
    margin-bottom: 22px;
  }
`;

const StyledHeader = styled.div`
  font-family: "Nimbus Sans Novus Regular";
  font-size: 20px;
  font-weight: var(--beacon-font-weight-bold);
  line-height: 1.4;
  letter-spacing: 0.02px;
  padding-bottom: 12px;
  @media (max-width: 768px) {
    font-size: 16px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
\` ;
  @media (max-width: 640px){
    font-size: 16px;
    padding-top:0px;
    padding-bottom: 16px;
  }
`;
const StyledHeaderCheckbox = styled(ProfileBeaconControl)`
  --beacon-form-label-font-size: 18px;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  @media (max-width: 640px){
    --beacon-form-label-font-size: 14px;
  }
`;

const StyledCheckbox = styled(ProfileBeaconControl)`
  padding-top: 10px;
  padding-bottom: 10px;
  --beacon-form-label-font-size: 18px;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  @media (max-width: 640px){
    --beacon-form-label-font-size: 14px;
  }
`;

export const MonthlyPerformanceInvestmentModal = ({modalName, handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const overlay = "Monthly Performance Investment Options Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const filteredPlanProducts = UseAppSelector(getPlanProducts);
    const getFilteredFunds = (fundName: string ) => {
        return filteredPlanProducts?.filter((product: any) => product.globalFundGroupName === fundName);
    }

    const stockFunds = _.orderBy(getFilteredFunds("STOCKS"), 'longName', 'asc');
    const bondFunds = _.orderBy(getFilteredFunds("BONDS"), 'longName', 'asc');
    const moneyMarketFunds = _.orderBy(getFilteredFunds("MONEY MARKET/ STABLE VALUE"), 'longName', 'asc');
    const retirementFunds = _.orderBy(getFilteredFunds("RETIREMENT").concat(getFilteredFunds("RETIREMENT FUNDS")), 'longName', 'asc');
    const companyStockFunds = _.orderBy(getFilteredFunds("COMPANY STOCK"), 'longName', 'asc');

    const invOptionsChecked = UseAppSelector(getIsPerformanceInvOptionsChecked);
    const selectedServiceProducts = UseAppSelector(getSelectedPerformanceServiceProducts);
    const [selectedFunds, setSelectedFunds] = useState(selectedServiceProducts);
    const isInvOptionsChecked = selectedFunds.length === selectedServiceProducts.length ? false : invOptionsChecked;

    const getFooter = (checked: any) => {
        return <ReactModalFooter
            tertiaryButtonText={"Cancel"}
            primaryButtonText={"Update"}
            handleCancelClick={handleCloseModal}
            handleOnClick={() => updateInvestments()}
            tertiaryButtonId={ANALYTICS_IDS.InvOptionsModalSkipCancel}
            primaryButtonId={ANALYTICS_IDS.InvOptionsModalUpdateFunds}
            primaryButtonDisabled={!checked && true}
        />
    };

    const updateInvestments = () => {
        dispatch(setSelectedPerformanceServiceProducts(selectedFunds));
        if(isInvOptionsChecked)
            handleCloseModal();
    }

    const handleSelectAll = (event: any) => {
        let value = event.target.checked;
        if (value) {
            const planProductsCodes = filteredPlanProducts.map((product: any) => product.code);
            setSelectedFunds(planProductsCodes);
            dispatch(setIsPerformanceInvOptionsChecked(true));
        }
        else {
            setSelectedFunds([]);
            dispatch(setIsPerformanceInvOptionsChecked(false));
        }
    }
     const closeThisModal = () => {
                    dispatch(modalActions.closeModal());
                }

    const handleServiceProductsChange = (event: any) => {
        if (event.target.checked){
            setSelectedFunds([event.target.value, ...selectedFunds]);
            dispatch(setIsPerformanceInvOptionsChecked(true));
        }
        else {
            const funds = selectedFunds.filter((serviceProduct: any) => serviceProduct !== event.target.value)
            setSelectedFunds(funds);
            if(funds.length == 0)
                dispatch(setIsPerformanceInvOptionsChecked(false));
        }
    }

    return (
        <React.Fragment>
            <BeaconModal id={modalName} onClose={closeThisModal} footer={getFooter(isInvOptionsChecked)} actionZone={true}>

                <ReactModalContent>
                    <StyledContainer>
                        <ReactModalHeader modalTitle="Select investments in your plan"/>
                        Choose at least one investment to sign up for a subscription.
                        <StyledContent>
                            <ImageContent>
                                <img src={Indicator} alt="Indicator icon"/> Indicates your investment
                            </ImageContent>
                            <StyledCheckboxContainer>
                              <ProfileBeaconControlGroup>
                                {/* <StyledHeaderCheckbox label="Select All" checked={selectedFunds.length == filteredPlanProducts.length} onInput={handleSelectAll}/> */}
                                 <StyledHeaderCheckbox inline>
                                  <label slot="label" htmlFor='selectAll'>Select All</label>
                                  <input
                                  type='checkbox'
                                  name='selectAll'
                                  checked={selectedFunds.length == filteredPlanProducts.length}
                                   onChange={handleSelectAll}/>
                                </StyledHeaderCheckbox>
                                </ProfileBeaconControlGroup>
                        
                            </StyledCheckboxContainer>
                        </StyledContent>
                        { stockFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                STOCKS
                            </StyledHeader>
                            {stockFunds.map((fund: any) => {
                                // return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                //                        value={fund.code} checked={selectedFunds.includes(fund.code)} />
                                 return <ProfileBeaconControlGroup>
                                <StyledCheckbox inline>
                                  <label slot='label' htmlFor='Stocks'>{fund.longName}</label>
                                  <input
                                  type='checkbox'
                                  name='Stocks'
                                  onChange={handleServiceProductsChange}
                                 value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                                </StyledCheckbox>
                                </ProfileBeaconControlGroup>
                            })
                            }
                        </StyledSection>
                        }
                        { bondFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                BONDS
                            </StyledHeader>
                            {bondFunds.map((fund: any) => {
                                // return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                //                        value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                                // return <StyledCheckbox inline>
                                //   <label slot='label'>{fund.longName}</label>
                                //   <input
                                //   type='chexkbox'
                                //   onChange={handleServiceProductsChange}
                                //  value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                                // </StyledCheckbox>
                                return <ProfileBeaconControlGroup>
                                <StyledCheckbox inline>
                                  <label slot='label' htmlFor='Bonds'>{fund.longName}</label>
                                  <input
                                  type='checkbox'
                                  name='Bonds'
                                  onChange={handleServiceProductsChange}
                                 value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                                </StyledCheckbox>
                                </ProfileBeaconControlGroup>
                            })
                            }
                        </StyledSection>
                        }
                        { moneyMarketFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                MONEY MARKET / STABLE VALUE
                            </StyledHeader>
                            {moneyMarketFunds.map((fund: any) => {
                                // return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                //                        value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                                return <ProfileBeaconControlGroup>
                                <StyledCheckbox inline>
                                <label slot='label'htmlFor='moneyMarket'>{fund.longName}</label>
                                <input
                                type='checkbox'
                                name="moneyMarket"
                               onChange={handleServiceProductsChange}
                               value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                              </StyledCheckbox>
                              </ProfileBeaconControlGroup>
                              })
                            }
                        </StyledSection>
                        }
                        { retirementFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                RETIREMENT
                            </StyledHeader>
                            {retirementFunds.map((fund: any) => {
                                // return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                //                        value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                                return <ProfileBeaconControlGroup>
                                 <StyledCheckbox inline>
                                <label slot='label'htmlFor='retirement'>{fund.longName}</label>
                                <input
                                type='checkbox'
                                name='retirement'
                               onChange={handleServiceProductsChange}
                               value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                              </StyledCheckbox>   
                              </ProfileBeaconControlGroup>
                            })
                            }
                        </StyledSection>
                        }
                        { companyStockFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                COMPANY STOCK
                            </StyledHeader>
                            {companyStockFunds.map((fund: any) => {
                                // return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                //                        value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                               return <ProfileBeaconControlGroup>
                                <StyledCheckbox inline>
                                <label slot='label' htmlFor="CompanyStock">{fund.longName}</label>
                                <input
                                type='checkbox'
                                name="CompanyStock"
                               onChange={handleServiceProductsChange}
                               value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                              </StyledCheckbox>
                              </ProfileBeaconControlGroup> 
                            })
                            }
                        </StyledSection>
                        }
                    </StyledContainer>
                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}